import { render, staticRenderFns } from "./Vip_download.vue?vue&type=template&id=4abacc65&scoped=true"
import script from "./Vip_download.vue?vue&type=script&lang=js"
export * from "./Vip_download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abacc65",
  null
  
)

export default component.exports